import type { IBudgetItemValues } from './types'

const isEmptyAmount = (value: any) => {
  if (value === null || value === undefined || value === '') return true
  const amount = Number(String(value).replace(/,/g, ''))
  return isNaN(amount) || amount === 0
}

/**
 * A line of the template this project does not use: no money in any column and nothing written
 * against it. Only these can be hidden, which is what keeps the section and grand totals - which
 * go on summing every line - the same whether a line is hidden or not.
 *
 * Mirrors `isBudgetLineEmpty` in the backend's `utils/budget-lines`, which the PDF and Excel
 * writers apply before they print.
 */
export const isBudgetLineUnused = (values: IBudgetItemValues) => {
  if (!values) return true
  const amounts = [
    values.rehabCostBorrowerEstimated,
    values.rehabCostLenderApproved,
    values.rehabCostAlreadyPrepaid,
    values.lenderDisbursedAmount,
    values.borrowerResponsibility,
  ]
  if (!amounts.every(isEmptyAmount)) return false
  if (String(values.description || '').trim().length) return false
  if (String(values.note || '').trim().length) return false
  if (values.highlight) return false
  return true
}

/** Whether a line is currently kept off the budget. */
export const isBudgetLineHidden = (values: IBudgetItemValues) => !!values?.hidden && isBudgetLineUnused(values)
